export const formObjectHelper = (editData, data) => {
    return Object.entries(editData).reduce((acc, [key, val]) => {
        acc["id"] = data.id ?? null;
        acc[key] = data[key];
        return acc;
    }, {});
};
